import React, { createContext, useContext, useState, useCallback } from 'react';

// Create the context
const AppContext = createContext(null);

// Custom hook to use the context
export const useAppContext = () => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error('useAppContext must be used within an AppProvider');
  }
  return context;
};

// Provider component
export const AppProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false);

  const [toaster, setToaster] = useState({
    visible: false,
    message: '',
    type: 'success', // 'success' or 'error'
  });

  // Show loader
  const showLoader = useCallback(() => {
    setIsLoading(true);
  }, []);

  // Hide loader
  const hideLoader = useCallback(() => {
    setIsLoading(false);
  }, []);

  // Toggle loader
  const toggleLoader = useCallback(() => {
    setIsLoading((prev) => !prev);
  }, []);

  // Show toaster
  const showToaster = useCallback((message, type = 'success') => {
    setToaster({
      visible: true,
      message,
      type,
    });
  }, []);

  // Hide toaster
  const hideToaster = useCallback(() => {
    setToaster((prev) => ({
      ...prev,
      visible: false,
    }));
  }, []);

  const value = {
    isLoading,
    toaster,
    showLoader,
    hideLoader,
    toggleLoader,
    showToaster,
    hideToaster,
  };

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};

export default AppContext;
